export default {
  routers: [
    // 课程-详情
    {
      path: "/train/course/detail",
      name: "courseDetail",
      component: () => import("@/views/train/course/detailView.vue"),
      meta: { title: "课程" },
    },
    // 课程-学习
    {
      path: "/train/course/detail/play",
      name: "coursePlay",
      component: () => import("@/views/train/course/playView.vue"),
      meta: { title: "课程" },
    },
    // 直播-详情页
    {
      path: "/train/live/detail",
      name: "liveDetail",
      component: () => import("@/views/train/live/detailView.vue"),
    },
    // 直播-开播
    {
      path: "/train/live/debut/:id",
      name: "liveDebut",
      component: () => import("@/views/train/live/debutView.vue"),
      // component: () => import("@/views/train/live/ActiveLive.vue"),
    },
    // 班级-详情
    {
      path: "/train/class/detail",
      name: "classDetail",
      component: () => import("@/views/train/class/detailView.vue"),
      // redirect: { name: "MyDiary" },
    },
    //学员-详情
    {
      path: "/train/student/detail",
      name: "studentDetail",
      component: () => import("@/views/train/student/detailView.vue"),
      meta: { title: "学员" },
    },

    //讲师-详情
    {
      path: "/train/lecturer/detail",
      name: "lecturerDetail",
      component: () => import("@/views/train/lecturer/detailView.vue"),
      // meta: { title: "课程" },
    },
    // *********************************************************************

    //测验页面
    {
      path: "/train/class/components/quiz",
      name: "quiz",
      component: () => import("@/views/train/class/components/quizView.vue"),
      // redirect: { name: "MyDiary" },
    },
  ],
};
